import { Box } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import { TextSemiBold } from 'UiKit/typography';
import useGetTabOptions from 'View/host-stream/helpers/useGetTabOptions';
import { useBriefLiveState } from 'View/productivity-host/state';

import styles from './styles.module.css';

const Tab = () => {
  const { state, updateState } = useBriefLiveState();
  const { selectedTab } = state;

  const handleTabChange = (selectedTab) => {
    updateState({
      selectedTab,
    });
  };

  const getClassname = (isActive) => {
    return {
      tabContainer: isActive ? styles['tab__box--active'] : styles['tab__box--inactive'],
      text: isActive ? styles['tab__text--active'] : styles['tab__text--inactive'],
    };
  };

  return (
    <Box className={styles['tab__container']}>
      <Iteration
        items={useGetTabOptions()}
        render={(item) => {
          const isActive = selectedTab === item.type;
          const { tabContainer, text } = getClassname(isActive);
          return (
            <Box className={tabContainer} onClick={() => handleTabChange(item.type)}>
              <TextSemiBold className={text}>{item.label}</TextSemiBold>
            </Box>
          );
        }}
      />
    </Box>
  );
};

export default Tab;
